/**
 * HID klavye emülasyonu ile gelen OKUMALARI yakalar (kasa: KK-303 / KK-308,
 * yönetim: ürün formunda barkod ekleme).
 *
 * Kart okuyucu da barkod okuyucu da aynı wedge'dir; bu dinleyici ikisini
 * ayırt ETMEZ, ham metni verir. Ne olduğuna çağıran karar verir.
 *
 * Varsayılan olarak > 100 ms boşlukta tampon sıfırlanır —
 * okuyucu bir kodu onlarca milisaniyede "yazar"; insan bu hızda yazamaz.
 * Kasa, kısa barkodların elle girilmesi için bu eşikleri gevşetebilir.
 * Odak bir metin alanındaysa karışılmaz: o alan Enter'ı kendi işler
 * (`data-kart-okuyucu` ile işaretli alanlar hariç).
 */
export function hidOkuyucuDinle(
  cb: (okuma: string) => void,
  opts: { bosluk?: number; enAz?: number } = {},
): () => void {
  const bosluk = opts.bosluk ?? 100;
  const enAz = opts.enAz ?? 6;
  let tampon = "";
  let sonTus = 0;

  const dinle = (e: KeyboardEvent) => {
    // Kullanıcı bir metin alanına yazıyorsa karışma.
    const hedef = e.target as HTMLElement | null;
    if (
      hedef &&
      (/^(INPUT|TEXTAREA|SELECT)$/.test(hedef.tagName) || hedef.isContentEditable) &&
      !hedef.dataset.kartOkuyucu
    ) {
      tampon = "";
      return;
    }

    if (e.defaultPrevented || e.ctrlKey || e.metaKey || e.altKey) {
      tampon = "";
      return;
    }

    const simdi = performance.now();
    if (simdi - sonTus > bosluk) tampon = "";
    sonTus = simdi;

    if (e.key === "Backspace") {
      tampon = tampon.slice(0, -1);
      return;
    }
    if (
      e.key === "Escape" ||
      e.key === "Tab" ||
      e.key === "Delete" ||
      e.key === "F2"
    ) {
      tampon = "";
      return;
    }

    if (e.key === "Enter") {
      const okuma = tampon.trim();
      tampon = "";
      // Tek başına +/-/= kasanın adet kısayollarıdır; barkod değildir.
      if (okuma.length >= enAz && !/^[+=-]+$/.test(okuma)) {
        e.preventDefault();
        cb(okuma);
      }
      return;
    }
    // Barkodlar (EAN/Code128) rakam dışı karakter de içerebilir; MIFARE UID'i
    // hex'tir. Yazdırılabilir tek karakterler tamponlanır, kısayol
    // kombinasyonları (Ctrl/Alt/Meta) atlanır.
    if (e.key.length === 1 && !e.ctrlKey && !e.metaKey && !e.altKey) {
      tampon += e.key;
    }
  };

  window.addEventListener("keydown", dinle, true);
  return () => window.removeEventListener("keydown", dinle, true);
}
